var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9763 11.9911C23.9763 18.6071 18.6129 23.9704 11.9969 23.9704C5.38091 23.9704 0.0175781 18.6071 0.0175781 11.9911C0.0175781 5.37505 5.38091 0.0117188 11.9969 0.0117188C18.6129 0.0117188 23.9763 5.37505 23.9763 11.9911ZM13.0876 4.62854H15.4164H15.4173V7.14167H14.0681C14.0664 7.14167 14.0637 7.14161 14.0601 7.14154C13.9612 7.13952 13.1947 7.12385 13.1947 7.88824C13.1999 8.21052 13.1947 9.3248 13.1947 9.3248H15.4267L15.2459 11.8276H13.247V19.1999H10.2179V11.8756H8.56961V9.33165H10.1682C10.1682 9.07543 10.169 8.82905 10.1697 8.58793C10.1713 8.12085 10.1727 7.67354 10.1682 7.21281C10.1682 5.20968 11.7059 4.62854 13.0876 4.62854Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b38d3235.svg";
export { ForwardRef as ReactComponent };